export default "__VITE_ASSET__gqVPjt9A__"